module.exports = __webpack_public_path__ + "img/AK.58e2dc0e.jpg";